import * as Sentry from "@sentry/react";

import { version } from "../../../package.json";
import { getPlayerId } from "./common/utils/getPlayerId";

function getSentryConfig() {
  const environment = import.meta.env.MODE || "development";

  return {
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment,
    release: version,
    tracesSampleRate: 1.0,
    attachStacktrace: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      // Sentry.replayIntegration({
      //   maskAllText: false,
      //   maskAllInputs: false,
      //   blockAllMedia: false,
      // }),
    ],
  };
}

export function initSentry() {
  if (import.meta.env.DEV) {
    return;
  }

  try {
    const config = getSentryConfig();

    if (!config.dsn) {
      console.warn("Sentry DSN not provided. Sentry will not be initialized.");
      return;
    }

    Sentry.init(config);
    Sentry.setUser({ id: getPlayerId() });

    console.log("Sentry initialised successfully", {
      environment: config.environment,
    });
  } catch (error) {
    console.error("Failed to initialise Sentry:", error);
  }
}
